<template>
	<div class="verify-email">
		<VerifyEmailDialogHOC v-if="showVerifyEmailDialog" />
	</div>
</template>

<script>
import VerifyEmailDialogHOC from "./VerifyEmailDialogHOC";
export default {
	name: "VerifyEmail",
	inject: [ "isLoggedIn", "isVerified", ],
	components: {
		VerifyEmailDialogHOC,
	},
	computed: {
		showVerifyEmailDialog() {
			return this.isLoggedIn && !this.isVerified;
		},
	},
};
</script>

<style lang="scss" scoped></style>
